module.exports = __webpack_public_path__ + "static/img/6.991cb58.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/zh/6.png
// module id = G3Ah
// module chunks = 0